module.exports = __webpack_public_path__ + "static/07-a24ff630c82a8de4234d53c05cf327e3.jpg";